import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/src/layer/VectorImage';
import VectorSource from 'ol/source/Vector';
import { Fill, Stroke, Style } from 'ol/style';
import * as olColor from 'ol/color';
import { colors, mapConfig } from '../../../utils/config';

//set variables to update layer style paint function
let layer = null;
let source = null;
let lastLines = null;

export default function loadLines(map, lines, typeFilter, zoomLevel) {
	if (!map) {
		// remove lines if zoomed out
		if (zoomLevel < mapConfig.minZoomLevel.stops + mapConfig.minZoom) {
			layer.setSource(
				new VectorSource({
					features: [],
				}),
			);
			layer.set('newLines', lines);
			source.refresh();
			return;
		}

		checkFilter(typeFilter);
		//if layer is set set lines as value and force repaint to get layer function
		if (layer && lines !== lastLines) {
			layer.set('newLines', lines);
			source.refresh();
		}
		lastLines = lines;
		return;
	}
	lastLines = lines;
	source = new VectorSource({
		url: '/geojson/linesV6.geojson',
		format: new GeoJSON(),
	});
	const style2 = new Style({
		fill: new Fill({
			color: '#fc03c2',
		}),
		stroke: new Stroke({
			color: '#fc03c2',
			width: 3,
		}),
	});
	layer = new VectorLayer({
		background: '#1a2b39',
		source: source,
		style: function (feature) {
			//set alpha 0 if no match
			const noMatchColor = olColor.asString([0, 0, 0, 0]);
			//check validity of date and don't show feature if not valid
			//validFrom
			// let validFrom = feature.get('validFrom');
			// let validUntil = feature.get('validUntil');
			// let fromDate = new Date();
			// const now = new Date();
			// if (validFrom) {
			// 	fromDate = parseDate(validFrom);
			// 	//valid from is in future -> dont show feature
			// 	if (fromDate > now) {
			// 		style2.getStroke().setColor(noMatchColor);
			// 		return;
			// 	}
			// }
			// if (validUntil) {
			// 	let toDate = parseDate(validUntil);
			// 	//valid to is in past -> dont show feature
			// 	if (toDate < now) {
			// 		style2.getStroke().setColor(noMatchColor);
			// 		return;
			// 	}
			// }
			const color = getLineColor(feature.get('text'), feature?.values_?.textDiva);
			if (color === colors.sbahn) {
				style2.setZIndex(2);
			} else {
				style2.setZIndex(1);
			}
			let isMatch = false;
			const newLines = layer.get('newLines');
			//if newlines is null there is no filter so show all lines and return
			if (!newLines) {
				if (color) {
					style2.getStroke().setColor(color);
				}
				return style2;
			}

			//textDiva matches part of line id
			if (newLines[parseInt(feature.get('textDiva') + '')] !== undefined) {
				isMatch = true;
			} else if (newLines[feature.get('line')] !== undefined) {
				isMatch = true;
			} else if (newLines[feature.get('id')] !== undefined) {
				isMatch = true;
			}
			if (isMatch) {
				if (color) {
					style2.getStroke().setColor(color);
				}
			} else {
				style2.getStroke().setColor(noMatchColor);
			}
			return style2;
		},
	});
	layer.set('name', 'line2');
	map.addLayer(layer);
	checkFilter(typeFilter);
}

//if Haltestellen aren't visible in filter don't show lines
function checkFilter(typeFilter) {
	let isFiltered = true;
	if (typeFilter?.stops?.Linien && typeFilter?.stops?.Linien !== 0) {
		isFiltered = false;
	}
	if (isFiltered) {
		layer.setSource(
			new VectorSource({
				features: [],
			}),
		);
	} else {
		layer.setSource(source);
	}
}

// function parseDate(dateString) {
// 	let parsedDate = new Date(dateString);
// 	if (parsedDate.toString() === 'Invalid Date') {
// 		let dateArray = dateString.split('.');
// 		//check if date array is valid
// 		//handles only dates with format dd.mm.yyyy
// 		if (Array.isArray(dateArray) && dateArray.length === 3) {
// 			//dd.mm.yyyy -> new Date(year, monthIndex, day)
// 			// year -> index 2
// 			// month -> index 1, as month begins with zero parse to int and subtract 1
// 			// dd -> index 0
// 			parsedDate = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0]);
// 		}
// 	}
// 	return parsedDate;
// }

const getLineColor = (name, textDiva = '', defaultValue = false) => {
	//type = zacke
	if (name === '10' && textDiva === '21010_') {
		return colors.ubahn; //'#fcf403';
	}
	//type = seilbahn
	if (name === '20' && textDiva === '21020_') {
		return colors.ubahn; //'#fcf403';
	}
	//type = ubahn
	if (name.match(/^U\d+([AEae])?$/)) {
		return colors.ubahn; //'#0320fc';
	}
	//type = sbahn
	if (name.match(/^S\d+([AEae])?$/)) {
		return colors.sbahn; //'#03fc67';
	}
	//type = rbahn
	if (name.match(/^(IRE|R|RB|RE|MEX)\d+([AEae])?$/) || name.match(/^R-Bahn /)) {
		return colors.rbahn; // '#8a8a8a';
	}
	//type = taxi
	if (name.match(/^(RT|LT)\d+$/)) {
		return colors.bus; // '#8a8a8a';
	}
	//type = bus
	if (name.match(/^((N|X|BB)?\d+(\.\d+|[AaE])?|E)$/)) {
		return colors.bus; // '#fc0303';
	}
	return defaultValue;
};
